import { makeStyles } from '@material-ui/core/styles';
import { PrimaryColors } from '@/utils/constants';

const useStyles = makeStyles(
  ({ spacing }) => ({
    resizeButton: {
      width: '48px',
      height: '48px',
      padding: spacing(1),
      cursor: 'pointer',
      backgroundColor: PrimaryColors.light,
      border: 'none',
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    leftArrowWrapper: {
      marginRight: spacing(0.5),
    },
    rightArrowWrapper: {
      marginLeft: spacing(0.5),
    },
  }),
  { name: 'ResizeButton' },
);

export default useStyles;
